// Configuración de URLs y tokens de Tecnóm para cada marca
export const TECNOM_CONFIG = {
  FIAT: {
    url: "https://montironifiat.tecnomcrm.com/api/leads",
    token: process.env.REACT_APP_TECNOM_TOKEN, // Basic Auth para FIAT
    enabled: true,
  },
  FORD: {
    url: "https://montironiford.tecnomcrm.com/api/leads",
    token: process.env.REACT_APP_TECNOM_TOKEN, // Basic Auth para FORD
    enabled: true,
  },
  PEUGEOT: {
    url: "https://montironipeugeot.tecnomcrm.com/api/leads",
    token: process.env.REACT_APP_TECNOM_TOKEN, // Token pendiente
    enabled: true,
  },
  HYUNDAI: {
    url: "https://automont.tecnomcrm.com/api/leads",
    token: process.env.REACT_APP_TECNOM_TOKEN, // Token pendiente
    enabled: true,
  },
  JEEP: {
    url: "https://montironijeep.tecnomcrm.com/api/leads",
    token: process.env.REACT_APP_TECNOM_TOKEN, // Token pendiente
    enabled: true,
  },
  GAC: {
    url: "https://multimarcamontironi.tecnomcrm.com/api/leads",
    token: process.env.REACT_APP_TECNOM_TOKEN, // Token pendiente
    enabled: true,
  },
};

// Función para obtener la URL de Tecnóm según la marca
export const getTecnomUrl = (brand) => {
  const config = TECNOM_CONFIG[brand];
  if (!config) {
    console.warn(`No se encontró configuración para la marca: ${brand}`);
    return null;
  }

  // Si la marca no está habilitada, no enviar a Tecnóm
  if (!config.enabled) {
    console.log(`Marca ${brand} no habilitada, no se enviará a Tecnóm`);
    return null;
  }

  return config.url;
};

// Función para obtener el token de Tecnóm según la marca
export const getTecnomToken = (brand) => {
  const config = TECNOM_CONFIG[brand];
  if (!config) {
    console.warn(`No se encontró configuración para la marca: ${brand}`);
    return null;
  }

  if (!config.enabled) {
    console.log(`Marca ${brand} no habilitada, no se enviará a Tecnóm`);
    return null;
  }

  return config.token;
};

// Función para verificar si una marca está habilitada
export const isTecnomEnabled = (brand) => {
  const config = TECNOM_CONFIG[brand];
  return config ? config.enabled : false;
};

